import { globalVariables } from "helper/globalVariables";
import { dogAvatar } from "helper/images";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import moment from "moment";

export const CardComponent = ({ data, onClick = () => {} }) => {
  return (
    <div className="max-w-md mx-auto overflow-hidden bg-white bg-opacity-50 border-y-lime-200">
      {/* Card Header */}
      <div onClick={onClick} className="flex items-center p-4">
        <img
          className="w-12 h-12 rounded-full mr-4"
          src={data?.dogImage === "" ? dogAvatar : data?.dogImage}
          alt="Profile"
        />
        <div onClick={onClick}>
          <h2 className="text-lg font-semibold text-gray-800">
            {data?.registration_name
              ? data.registration_name ?? data.call_name
              : "-"}
          </h2>
        </div>
        <span
          className="h-7   ml-auto bg-gray-300 text-gray-800 text-xs font-medium me-2 px-2.5 py-1 pb-0.5 rounded-full "
          style={{
            border: "1px solid var(--gray-200, #EAECF0)",
            background: "var(--gray-50, #F9FAFB)",
            mixBlendMode: "multiply",
          }}
        >
          {data.status ?? "Active"}
        </span>
      </div>

      <div className="px-4 pb-2">
        <div className="flex items-center py-1">
          <p className="text-sm text-gray-700"> {globalVariables.breed}: </p>
          <p className="text-sm text-gray-600 ml-1">{data?.breed_mix || data?.breed}</p>
        </div>
        <div className="flex items-center py-1">
          <p className="text-sm text-gray-700"> {globalVariables.sex}: </p>
          <p className="text-sm text-gray-600 ml-1">{data?.gender}</p>
        </div>
        <div className="flex items-center py-1">
          <p className="text-sm text-gray-700"> {globalVariables.dob}: </p>
          <p className="text-sm text-gray-600 ml-1">
            {moment(data.date_of_birth).format(DEFAULT_DATE_FORMAT) ?? "-"}
          </p>
        </div>
      </div>
    </div>
  );
};
